import React from "react";

import { AddRounded, MenuRounded, RefreshRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Constants } from "../../../config/constants";
import useFirebase from "../../../config/context/firebaseContext";
import useMainState from "../../../config/context/mainStateContext";
import useModal from "../../../config/context/modalContext";
import { Dev } from "../../../config/util/consoleUtil";

import MainSolidButton from "../../../components/MainSolidButton";
import PageHeader from "../../../components/PageHeader";
import ScheduleItem from "./components/ScheduleItem";

import { BusSchedulesType } from "../../../types/bus";
import ModalWriteSchedule from "./components/ModalWriteSchedule";

export default function AdminBusSchedulePage() {
  const navigate = useNavigate();
  const { getConfig, forceRefreshConfigs } = useFirebase();
  const { setShowSideMenuDrawer } = useMainState();
  const { pushAlert } = useModal();

  const [loading, setLoading] = React.useState(false);

  const [showModalWrite, setShowModalWrite] = React.useState(false);

  const [schedules, setSchedules] = React.useState<BusSchedulesType>({});

  const getSchedules = async () => {
    try {
      const configSchedules = getConfig("bus_schedules") as BusSchedulesType;
      const busSchedules = { ...Constants.busSchedules, ...configSchedules } as BusSchedulesType;
      setSchedules(busSchedules);
    } catch (error: any) {
      console.log(...new Dev("getSchedules", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao obter itinerários",
      });
    }
  };

  const handleReload = async () => {
    setLoading(true);
    await forceRefreshConfigs();
    await getSchedules();
    setLoading(false);
  };

  const onCloseModalHandler = (reload?: boolean) => {
    setShowModalWrite(false);
    if (reload) handleReload();
  };

  React.useEffect(() => {
    handleReload();
  }, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Itinerários"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
          rightIcon={<RefreshRounded />}
          onRightAction={handleReload}
        />

        {/* Modal */}

        {showModalWrite && <ModalWriteSchedule onClose={onCloseModalHandler} />}

        {/* Banners */}

        <Box mt={4} mb={2}>
          <MainSolidButton
            icon={<AddRounded />}
            text="Adicionar Itinerário"
            onClick={() => setShowModalWrite(true)}
          />
        </Box>

        <Box>
          {loading ? (
            [1, 2, 3].map((item) => (
              <Skeleton
                key={item}
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={100}
                sx={{ mb: 2, borderRadius: "15px" }}
              />
            ))
          ) : (
            <>
              {Object.keys(schedules).map((id) => (
                <ScheduleItem key={id} id={id} item={schedules[id]} handleReload={handleReload} />
              ))}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
